// extracted by mini-css-extract-plugin
module.exports = {"css":"App_css__3xh0T"};